export default __webpack_public_path__ + "static/maintain-ai-ac23ddf416dfd55ce0819f160f931bbb.png";